import React, {Component} from 'react';
import PropiedadIntelectual from '.';
import Detalle from '../CatedraOMC/Detalle';
import InvestigacionesDetalle from './detalle-investigaciones';
import Utils from '../utils'

class WithData extends Component{
  constructor(){
    super();
    this.state ={
      textPropInt: "",
      cursosPI: [],
      cursosCSP: [],
      cursosCSP_feb: [],
      cursosCSP_mar: [],
      cursosCSP_abr: [],
      cursosCSP_may: [],
      cursosCSP_jun: [],
      cursosCSP_jul: [],
      cursosCSP_ago: [],
      cursosCSP_sep: [],
      cursosCSP_oct: [],
      cursosCSP_nov: [],
      cursosCSP_past: [],
      cursosCSP_bad_date: [],
      inv_derechosMarcas: [],
      inv_politicasPublicas: [],
      inv_derechosAutor: []
    }
  }

  componentDidMount(){
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer pat6jAlLNNigrNUEE.b55c43506b2f3705ce219e322d78ae26763b9233d82db88ffeacfab50cf55d98");
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Cursos-Info", requestOptions)
    .then(response=>response.json())
    .then(data=>{
        data.records.forEach(element => {
            if (element.fields.Nombre == "PI") {
                this.setState({
                  textPropInt : element.fields.Descripcion
                });            
            }
        });
    })
    .catch(error=>{
      console.error(error);
    })

    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Cursos", requestOptions)
    .then(response=>response.json())
    .then(data=>{
      var arrCursosPI = [];
      var arrCursosCSP = [];
      var arrInvDA = [];
      var arrInvPP = [];
      var arrInvDM = [];
      data.records.forEach(responsable => {
        if (responsable.fields.Activo && responsable.fields.Tipo[0] == "PI") {
          arrCursosPI.push(responsable);
        }
        if (responsable.fields.Activo && responsable.fields.Tipo[0] == "CSP") {
          arrCursosCSP.push(responsable);
        }
        if (responsable.fields.Activo && responsable.fields.Tipo.includes('INV-DM')) {
          arrInvDM.push(responsable);
        }
        if (responsable.fields.Activo && responsable.fields.Tipo.includes("INV-PP")) {
          arrInvPP.push(responsable);
        }
        if (responsable.fields.Activo && responsable.fields.Tipo.includes("INV-DA")) {
          arrInvDA.push(responsable);
        }

      });
      arrCursosCSP = Utils.oldestFirst(arrCursosCSP, "fechaOrganizacional");
      arrCursosPI = Utils.newestFirst(arrCursosPI, "fechaOrganizacional");
      arrInvDA = Utils.newestFirst(arrInvDA, "fechaOrganizacional");
      arrInvPP = Utils.newestFirst(arrInvPP, "fechaOrganizacional");
      arrInvDM = Utils.newestFirst(arrInvDM, "fechaOrganizacional");

      var cursosCSPOrdenados = Utils.getEventsByMonth(arrCursosCSP);
      
      //TO DO: eliminar los arrays y mostrar solo con el prop
      this.setState({
        cursosPI : arrCursosPI,
        cursosCSP: arrCursosCSP,
        cursosCSP_feb: cursosCSPOrdenados.feb,
        cursosCSP_mar: cursosCSPOrdenados.mar,
        cursosCSP_abr: cursosCSPOrdenados.abr,
        cursosCSP_may: cursosCSPOrdenados.may,
        cursosCSP_jun: cursosCSPOrdenados.jun,
        cursosCSP_jul: cursosCSPOrdenados.jul,
        cursosCSP_ago: cursosCSPOrdenados.ago,
        cursosCSP_sep: cursosCSPOrdenados.sep,
        cursosCSP_oct: cursosCSPOrdenados.oct,
        cursosCSP_nov: cursosCSPOrdenados.nov,
        cursosCSP_past: cursosCSPOrdenados.past,
        cursosCSP_bad_date: cursosCSPOrdenados.out,
        inv_derechosMarcas: arrInvDM,
        inv_politicasPublicas: arrInvPP,
        inv_derechosAutor: arrInvDA
      });
    })
    .catch(error=>{
      console.error(error);
    })


  }

  render(){
    let id = this.props.match.params.id
    if(id && (this.state.cursosPI.length > 0 || 
              this.state.cursosCSP.length > 0 ||
              this.state.inv_derechosAutor > 0 ||
              this.state.inv_derechosMarcas > 0 ||
              this.state.inv_politicasPublicas > 0)){
      const newArr = this.state.cursosCSP.concat(this.state.cursosPI);
      const newArrInv = this.state.inv_derechosAutor.concat(this.state.inv_derechosMarcas)
                                                    .concat(this.state.inv_politicasPublicas);

      const res = newArr.filter(item=>item.id === id)[0];

      if (res) {
        const detalleRes = {
          state:{
            props: {
              fromTitle:"Propiedad Intelectual",
              fromLink:"/propiedad-intelectual",
              mainState:{
                ...res
              }
            }
          }
        }

        return (<Detalle location={detalleRes} />);
          
      } else {
        const resInv = newArrInv.filter(item=>item.id === id)[0];
        const detalleRes = {
          state:{
            props: {
              fromTitle:"Investigaciones",
              fromLink:"/propiedad-intelectual",
              mainState:{
                ...resInv
              }
            }
          }
        }

        return (<InvestigacionesDetalle location={resInv} />);

      }

    }else{
      return (
        <div>
          <PropiedadIntelectual textPropInt={this.state.textPropInt}
                                cursosPI={this.state.cursosPI}
                                cursosCSP={this.state.cursosCSP}
                                cursosCSP_feb={this.state.cursosCSP_feb}
                                cursosCSP_mar={this.state.cursosCSP_mar}
                                cursosCSP_abr={this.state.cursosCSP_abr}
                                cursosCSP_may={this.state.cursosCSP_may}
                                cursosCSP_jun={this.state.cursosCSP_jun}
                                cursosCSP_jul={this.state.cursosCSP_jul}
                                cursosCSP_ago={this.state.cursosCSP_ago}
                                cursosCSP_sep={this.state.cursosCSP_sep}
                                cursosCSP_oct={this.state.cursosCSP_oct}        
                                cursosCSP_nov={this.state.cursosCSP_nov}
                                cursosCSP_past={this.state.cursosCSP_past}
                                cursosCSP_bad_date={this.state.cursosCSP_bad_date}
                                inv_derechosMarcas={this.state.inv_derechosMarcas}
                                inv_politicasPublicas={this.state.inv_politicasPublicas}
                                inv_derechosAutor={this.state.inv_derechosAutor}
                                />
        </div>
      )
    }
  }
}

export default WithData;
